/* eslint-disable max-len */
const CartIcon = () => (
  <svg aria-hidden="true" height="22px" version="1.1" viewBox="0 0 22 22" width="22px" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" id="Symbols-55" stroke="none" strokeWidth="1">
      <g fill="#FFFFFF" id="nav/elements/cart">
        <g>
          <path d="M10,20.5 C10,21.328 9.328,22 8.5,22 C7.672,22 7,21.328 7,20.5 C7,19.672 7.672,19 8.5,19 C9.328,19 10,19.672 10,20.5" id="cartIcon-Fill-1" />
          <path d="M20,20.5 C20,21.328 19.328,22 18.5,22 C17.672,22 17,21.328 17,20.5 C17,19.672 17.672,19 18.5,19 C19.328,19 20,19.672 20,20.5" id="cartIcon-Fill-3" />
          <path d="M19,17 L8,17 C7.547,17 7.15,16.695 7.034,16.258 L3.231,2 L1,2 C0.447,2 0,1.553 0,1 C0,0.447 0.447,0 1,0 L4,0 C4.453,0 4.85,0.305 4.966,0.742 L8.769,15 L19,15 C19.553,15 20,15.447 20,16 C20,16.553 19.553,17 19,17" id="cartIcon-Fill-5" />
          <path d="M20,12 L7,12 C6.447,12 6,11.553 6,11 C6,10.447 6.447,10 7,10 L19.153,10 L19.819,6 L5,6 C4.447,6 4,5.553 4,5 C4,4.447 4.447,4 5,4 L21,4 C21.294,4 21.573,4.129 21.763,4.354 C21.953,4.578 22.035,4.874 21.986,5.164 L20.986,11.164 C20.906,11.646 20.489,12 20,12" id="cartIcon-Fill-7" />
          <polyline id="Fill-9" points="5 5 21 5 20 11 7 11" />
        </g>
      </g>
    </g>
  </svg>
)

export default CartIcon
